import { render, staticRenderFns } from "./comment-add-or-update.vue?vue&type=template&id=1aef27ba&"
import script from "./comment-add-or-update.vue?vue&type=script&lang=js&"
export * from "./comment-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./comment-add-or-update.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports